document.addEventListener('alpine:init', () => {
    // Per-filter-group local state. Registered as a named Alpine component so the
    // template can use `x-data="filterGroup"` instead of an inline object literal
    // (inline `{ isOpen: false }` breaks ACF's JSX block parser, which tries to
    // JSON.parse any attribute value starting with `{`).
    Alpine.data('filterGroup', () => ({
        isOpen: false,
    }));

    Alpine.data('FilterableProjectsGrid', (filterKeys = []) => ({
        filtersOpen: false,
        selectedFilters: Object.fromEntries(filterKeys.map(key => [key, []])),
        isDesktop: window.matchMedia('(min-width: 1024px)').matches,
        _filterTimeout: null,

        get hasSelectedFilters() {
            return Object.values(this.selectedFilters).some(arr => arr.length > 0);
        },

        init() {
            // Track lg breakpoint
            const mq = window.matchMedia('(min-width: 1024px)');
            mq.addEventListener('change', (e) => {
                this.isDesktop = e.matches;
            });

            // Restore filters from URL on init (before $watch is wired up, so
            // the restore doesn't immediately re-fire applyFilters via the watcher).
            this.restoreFromUrl();

            // Live filtering: any change to selectedFilters re-runs applyFilters,
            // debounced so rapid clicks coalesce into a single request.
            this.$watch('selectedFilters', () => {
                clearTimeout(this._filterTimeout);
                this._filterTimeout = setTimeout(() => this.applyFilters(), 200);
            });
        },

        applyFilters() {
            const params = new URLSearchParams();
            params.set('page', '1');

            Object.entries(this.selectedFilters).forEach(([key, slugs]) => {
                slugs.forEach(slug => params.append(`${key}[]`, slug));
            });

            const url = `/wp-json/origins/v1/filter-projects?${params.toString()}`;

            htmx.ajax('GET', url, {
                target: '#projects-grid',
                swap: 'innerHTML',
            });

            // Update URL for shareability
            this.updateUrl();
        },

        clearFilters() {
            Object.keys(this.selectedFilters).forEach(key => {
                this.selectedFilters[key] = [];
            });
            this.applyFilters();
        },

        restoreFromUrl() {
            const params = new URLSearchParams(window.location.search);
            let hasFilters = false;

            Object.keys(this.selectedFilters).forEach(key => {
                const values = params.getAll(`${key}[]`);
                if (values.length) {
                    this.selectedFilters[key] = values;
                    hasFilters = true;
                }
            });

            if (hasFilters) {
                this.applyFilters();
            }
        },

        updateUrl() {
            const params = new URLSearchParams();

            Object.entries(this.selectedFilters).forEach(([key, slugs]) => {
                slugs.forEach(slug => params.append(`${key}[]`, slug));
            });

            const queryString = params.toString();
            const newUrl = queryString
                ? `${window.location.pathname}?${queryString}`
                : window.location.pathname;

            history.replaceState(null, '', newUrl);
        },
    }));
});
